module.exports = __webpack_public_path__ + "static/media/zeus1.64c44e97.png";